import { Button } from '@components/button';
import { ScrollButton } from '@components/scrollButton';
import { sendAnalyticsEvent } from '@lib/analytics/analytics';
import { classNames } from '@lib/classNames/classNames';
import { memo, useCallback } from 'react';

import { SecondaryButtonParams } from './types';

interface SecondaryButtonProps extends SecondaryButtonParams {
  secondaryButtonHrefWithUtm: string | undefined;
  className?: string;
}

export const SecondaryButton = memo(
  ({
    secondaryButtonContent,
    secondaryButtonHrefWithUtm,
    secondaryButtonAnalyticsEvent,
    secondaryButtonHref,
    secondaryButtonVariant = 'secondary',
    className,
  }: SecondaryButtonProps) => {
    const handleSecondaryButtonClick = useCallback(() => {
      if (secondaryButtonAnalyticsEvent) {
        sendAnalyticsEvent(secondaryButtonAnalyticsEvent);
      }
    }, [secondaryButtonAnalyticsEvent]);

    return (
      <>
        {!!secondaryButtonContent && !!secondaryButtonHrefWithUtm && (
          <Button
            className={classNames({
              cls: 'flex h-14 w-60 items-center justify-center max-sm:w-full',
              additional: [className],
            })}
            variant={secondaryButtonVariant}
            disabled={false}
            role="button"
            ariaLabel={secondaryButtonContent as string}
            href={secondaryButtonHrefWithUtm}
            onClick={
              secondaryButtonAnalyticsEvent
                ? handleSecondaryButtonClick
                : undefined
            }
            target="_blank"
          >
            {secondaryButtonContent}
          </Button>
        )}

        {!!secondaryButtonContent && !secondaryButtonHref && (
          <ScrollButton
            target="form"
            className={classNames({
              cls: 'flex h-14 w-60 items-center justify-center max-sm:w-full',
              additional: [className],
            })}
            variant={secondaryButtonVariant}
          >
            {secondaryButtonContent}
          </ScrollButton>
        )}
      </>
    );
  },
);

SecondaryButton.displayName = 'SecondaryButton';
